import React from 'react'
import ReactDOM from 'react-dom/client'
import Providers from './app/providers'
import Router from './app/router'
import { initOfflineQueue } from './shared/api/offlineQueue'
import 'antd/dist/reset.css'
import './styles/mobile.css'

// Phase HR-002 hardening — boot the offline write queue. Replays any
// requests left over from a previous session (e.g. tablet was offline,
// browser closed, etc.) and wires up online/focus listeners.
initOfflineQueue()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <Router />
    </Providers>
  </React.StrictMode>,
)
